import { render, staticRenderFns } from "./ShowcaseContributionPopup.vue?vue&type=template&id=1248a8e8&"
import script from "./ShowcaseContributionPopup.vue?vue&type=script&lang=js&"
export * from "./ShowcaseContributionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports